/* The Medispa Edit - Rewards bar v6, gift ladder (Om Sri Keshari), 9 Oct 2026 (Neety's levels; no gift with discount codes).
   Config comes from snippets/medispa-rewards-bar.liquid (window.MRW_CFG).
   - One bar, four milestones: free UK delivery (t1), then the gift ladder:
     2 samples with every order, deluxe sample at GBP 150, 15 ml travel size at
     GBP 250, gift set at GBP 350. One gift line per order, highest level only.
   - Places the bar on the product page, cart drawer, cart page, inside the sticky
     add-to-bag bar, and as a small floating pill on other pages
   - Keeps exactly one GBP 0 Free Sample line, the variant for the current level
   - Unlock moment: congratulations pop-up (own modal dialog, above the cart drawer)
     with confetti; tapping the card fires more (no confetti with reduced motion)
   - Drawer: price-aware suggestions that close the gap to the next reward */
(function () {
  'use strict';
  var C = window.MRW_CFG;
  if (!C || window.__mrw) return;
  window.__mrw = true;

  var T1 = C.t1;
  var GIFTS = (C.gifts || []).filter(function (g) { return g && g.id; }).sort(function (a, b) { return a.min - b.min; });
  var TOP = GIFTS.length ? GIFTS[GIFTS.length - 1].min : T1;
  var MS = [T1].concat(GIFTS.filter(function (g) { return g.min > 0; }).map(function (g) { return g.min; }));
  var HANDLE = 'free-sample', SRC = 'medispa-rewards';
  var nativeFetch = window.fetch.bind(window);
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var state = { total: C.total || 0, paid: C.paid || 0, ids: C.ids || [] };
  var shownPct = null;

  /* ---------- helpers ---------- */
  function money(c) { return '£' + (Math.max(0, c) / 100).toFixed(2); }
  /* level = number of milestones reached (0..MS.length); MAX = all of them */
  var MAX = MS.length;
  function level(t, paid) { if (!paid) return 0; var n = 0; MS.forEach(function (m) { if (t >= m) n++; }); return n; }
  function pctOf(t) { return Math.max(0, Math.min(100, (t / TOP) * 100)); }
  function gift(t) { var g = GIFTS[0] || null; GIFTS.forEach(function (x) { if (t >= x.min) g = x; }); return g; }
  function nextGift(t) { for (var i = 0; i < GIFTS.length; i++) if (GIFTS[i].min > t) return GIFTS[i]; return null; }
  function short(g) { return g ? g.name.replace(/^an? /, '') : ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function amt(c) { return '<span class="mrw__amt">' + money(c) + '</span>'; }

  function fullMsg(t, paid) {
    var L = level(t, paid), g = gift(t), n = nextGift(t);
    if (paid && state.coded) return (t >= T1 ? 'Free UK delivery unlocked. ' : '') + 'Complimentary samples are not included when a discount code is used';
    if (paid && L === MAX) return 'Free UK delivery + <b>' + esc(g.name) + '</b> unlocked &mdash; hand-picked by our team';
    if (!paid || t < T1) return 'Add ' + amt(T1 - t) + ' more for <b>free UK delivery</b>';
    if (g && g.min > 0) return '<b>' + esc(short(g).charAt(0).toUpperCase() + short(g).slice(1)) + '</b> unlocked. Add ' + amt(n.min - t) + ' more for <b>' + esc(n.name) + '</b>';
    return 'Free UK delivery unlocked. Add ' + amt(n.min - t) + ' more for <b>' + esc(n.name) + '</b>';
  }
  function miniMsg(t, paid) {
    if (!paid) return 'Free UK delivery over ' + money(T1).replace('.00', '') + ' &middot; <b>a complimentary 4ml sample</b> with every order';
    if (state.coded) return t >= T1 ? '<b>Free UK delivery</b> unlocked' : amt(T1 - t) + ' away from <b>free UK delivery</b>';
    var L = level(t, paid), n = nextGift(t);
    if (L === MAX) return '<b>Free UK delivery + ' + esc(gift(t).name) + '</b> unlocked';
    if (t < T1) return amt(T1 - t) + ' away from <b>free UK delivery</b>';
    return amt(n.min - t) + ' away from <b>' + esc(n.name) + '</b>';
  }

  function setFill(root, pct) {
    root.querySelectorAll('[data-mrw-fill]').forEach(function (f) {
      f.style.transform = 'translateX(-' + (100 - pct).toFixed(2) + '%)';
    });
  }
  function setHTML(node, html) {
    if (!node || node.innerHTML === html) return;
    var before = node.querySelector('.mrw__amt');
    var oldAmt = before ? before.textContent : null;
    node.innerHTML = html;
    var after = node.querySelector('.mrw__amt');
    if (after && oldAmt && after.textContent !== oldAmt && !reduce) {
      after.classList.add('is-bump');
      setTimeout(function () { after.classList.remove('is-bump'); }, 650);
    }
  }

  /* ---------- painting ---------- */
  function paint(el) {
    var t = state.total, p = state.paid, pct = pctOf(p ? t : 0), L = level(t, p);
    if (el.hasAttribute('data-mrw')) {
      var step = el.querySelector('[data-mrw-step]');
      var pc = el.querySelector('[data-mrw-pct]');
      if (step) step.textContent = L + ' of ' + MAX + ' rewards unlocked';
      if (pc) pc.textContent = Math.floor(pct) + '% complete';
      setHTML(el.querySelector('[data-mrw-msg]'), fullMsg(t, p));
      var mss = el.querySelectorAll('.mrw__m');
      for (var mi = 0; mi < mss.length; mi++) mss[mi].classList.toggle('is-next', mi === L);
      var tr = el.querySelector('[data-mrw-track]');
      if (tr) tr.setAttribute('aria-valuenow', String(Math.floor(pct)));
    } else {
      setHTML(el.querySelector('[data-mrw-mini-msg]'), miniMsg(t, p));
    }
    el.classList.toggle('is-ship', L >= 1);
    el.classList.toggle('is-g1', L >= 2);
    el.classList.toggle('is-g2', L >= 3);
    el.classList.toggle('is-done', L === MAX);
    setFill(el, pct);
  }
  function all() { return document.querySelectorAll('[data-mrw],[data-mrw-mini]'); }
  function paintAll() { all().forEach(paint); shownPct = pctOf(state.paid ? state.total : 0); }

  /* A new bar starts from what the shopper last saw (0 on first sight) and grows */
  function grow(el) {
    var from = shownPct == null ? 0 : shownPct;
    el.querySelectorAll('[data-mrw-fill]').forEach(function (f) {
      f.style.transition = 'none';
      f.style.transform = 'translateX(-' + (100 - from).toFixed(2) + '%)';
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.querySelectorAll('[data-mrw-fill]').forEach(function (f) { f.style.transition = ''; });
        paint(el);
      });
    });
  }

  function fromTemplate(where) {
    var tpl = document.getElementById('mrw-tpl');
    if (!tpl || !tpl.content.firstElementChild) return null;
    var wrap = document.createElement('div');
    wrap.className = 'mrw-slot mrw-slot--' + where;
    var bar = tpl.content.firstElementChild.cloneNode(true);
    wrap.appendChild(bar);
    paint(bar);
    grow(bar);
    return wrap;
  }
  function miniNode(cls) {
    var d = document.createElement('div');
    d.className = cls;
    d.setAttribute('data-mrw-mini', '');
    if (cls === 'mrw-stk') {
      d.innerHTML = '<p class="mrw-stk__msg" data-mrw-mini-msg></p><div class="mrw-stk__track"><span class="mrw__fill" data-mrw-fill></span></div>';
    } else {
      d.id = 'mrw-pill';
      d.setAttribute('role', 'status');
      d.innerHTML = '<div class="mrw-pill__row"><p class="mrw-pill__msg" data-mrw-mini-msg></p>' +
        '<button type="button" class="mrw-pill__view" data-mrw-view>View bag</button>' +
        '<button type="button" class="mrw-pill__x" data-mrw-dismiss aria-label="Hide">&times;</button></div>' +
        '<div class="mrw-pill__track"><span class="mrw__fill" data-mrw-fill></span></div>';
    }
    paint(d);
    grow(d);
    return d;
  }

  /* ---------- placement ---------- */
  function place() {
    var p = state.paid;
    /* Product page: under the delivery line in the buy box */
    var ship = document.getElementById('mcro-ship');
    if (ship && !document.querySelector('.mrw-slot--pdp')) {
      var s1 = fromTemplate('pdp');
      if (s1) ship.insertAdjacentElement('afterend', s1);
    }
    /* Sticky add-to-bag bar on the product page */
    var stk = document.querySelector('.mp-sticky');
    if (stk && !stk.querySelector('.mrw-stk')) stk.insertBefore(miniNode('mrw-stk'), stk.firstChild);

    /* Cart drawer: bar at the top, smart picks above the summary */
    var dc = document.querySelector('cart-drawer-component .cart-drawer__content');
    if (dc) {
      var has = p > 0 && !dc.closest('.cart-drawer--empty');
      var bar = dc.querySelector('.mrw-slot--drawer');
      if (has && !bar) { var s2 = fromTemplate('drawer'); if (s2) dc.insertBefore(s2, dc.firstChild); }
      else if (!has && bar) bar.remove();
      /* smart picks sit directly under the bar */
      var up = dc.querySelector('#mrw-up');
      var anchor = dc.querySelector('.mrw-slot--drawer');
      if (has && upHTML && anchor) {
        if (!up) {
          up = document.createElement('div');
          up.id = 'mrw-up';
          up.className = 'mrw-up';
          up.innerHTML = upHTML;
        }
        if (anchor.nextElementSibling !== up) anchor.insertAdjacentElement('afterend', up);
      } else if (up) {
        up.remove();
      }
    }
    /* Cart page: above the totals */
    if (C.isCart && p > 0) {
      document.querySelectorAll('.cart-totals').forEach(function (ct) {
        if (ct.closest('cart-drawer-component')) return;
        var prev = ct.previousElementSibling;
        if (prev && prev.classList.contains('mrw-slot--page')) return;
        var s3 = fromTemplate('page');
        if (s3) ct.parentNode.insertBefore(s3, ct);
      });
    }
    /* Everywhere else: a small floating pill while a reward is still to unlock */
    var pill = document.getElementById('mrw-pill');
    var wantPill = !C.isCart && !C.isProduct && p > 0 && level(state.total, p) < MAX && store('mrw_pill_off') !== '1';
    if (wantPill && !pill) document.body.appendChild(miniNode('mrw-pill'));
    else if (!wantPill && pill) pill.remove();
  }

  /* ---------- cart API ---------- */
  function post(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return nativeFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function ping(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: SRC, data: { source: SRC, itemCount: cart.item_count, didError: false } }
      }));
    } catch (e) {}
  }

  /* Exactly one Free Sample line: the variant for the current level. None when the bag
     holds no paid items. Any other Free Sample line is removed. No shopper choice. */
  var reorderSig = '';
  function reconcile(cart) {
    var items = cart.items || [], paid = 0, ids = [];
    items.forEach(function (l) {
      if (l.handle !== HANDLE) { paid += l.quantity; ids.push(l.product_id); }
    });
    /* no complimentary gift when a discount code is applied (Neety, 9 Oct) */
    var coded = (cart.discount_codes || []).some(function (d) { return d && d.applicable; });
    var want = paid > 0 && !coded ? gift(cart.total_price || 0) : null;
    var TEAM = want ? want.id : 0, ops = [], team = null;
    items.forEach(function (l) {
      if (l.handle !== HANDLE) return;
      if (TEAM && l.variant_id === TEAM && !team) team = l;
      else ops.push({ id: l.key, quantity: 0 });
    });
    var eligible = !!TEAM;
    var needAdd = false;
    if (eligible) {
      if (!team) needAdd = true;
      /* keep the gift line as the newest line in the cart (Shopify lists newest first),
         so it never ends up between products; the bag shows it at the bottom */
      else if (items.indexOf(team) !== 0 && reorderSig !== cart.token + ':' + items.length) { reorderSig = cart.token + ':' + items.length; ops.push({ id: team.key, quantity: 0 }); needAdd = true; }
      else if (team.quantity !== 1) ops.push({ id: team.key, quantity: 1 });
    } else if (team) {
      ops.push({ id: team.key, quantity: 0 });
    }
    var done = function (c, changed) { return { cart: c, paid: paid, ids: ids, changed: changed, coded: coded }; };
    if (!ops.length && !needAdd) return Promise.resolve(done(cart, false));
    var p = Promise.resolve();
    ops.forEach(function (op) { p = p.then(function () { return post('/cart/change.js', op); }); });
    if (needAdd) p = p.then(function () { return post('/cart/add.js', { items: [{ id: TEAM, quantity: 1 }] }); });
    return p.then(getCart).then(function (c) { return done(c, true); });
  }

  /* ---------- unlock moment ---------- */
  /* Pop-up + confetti live in their own modal <dialog>. The cart drawer is a
     modal dialog in the browser top layer, so anything on <body> (even with a huge
     z-index) sits behind it. A second showModal() dialog stacks above the drawer. */
  var pop = null;
  function tickSvg() { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>'; }
  function giftSvg() { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3.2-5.5-3.2-5.5-.8C6.5 7 9 7 12 7zM12 7c1.5-3.2 5.5-3.2 5.5-.8C17.5 7 15 7 12 7z"/></svg>'; }
  function popCopy(L, t) {
    var g = gift(t), n = nextGift(t);
    if (L >= 2 && g) return {
      icon: giftSvg(),
      title: 'You&rsquo;ve unlocked <b>' + esc(g.name) + '</b>',
      body: 'Our team will choose your gift to suit your routine and add it to your order, with free UK delivery.' +
        (n ? ' Add ' + amt(n.min - t) + ' more for <b>' + esc(n.name) + '</b>.' : ''),
      pct: pctOf(t), cta: n ? 'Continue shopping' : 'Continue'
    };
    return {
      icon: tickSvg(),
      title: 'You&rsquo;ve unlocked <b>FREE UK delivery</b>',
      body: n ? 'Add ' + amt(n.min - t) + ' more and get <b>' + esc(n.name) + '</b>, hand-picked by our team.' : 'Your complimentary samples are added to your order.',
      pct: pctOf(t), cta: 'Continue shopping'
    };
  }
  function buildPop() {
    if (pop && document.body.contains(pop)) return pop;
    pop = document.createElement('dialog');
    pop.className = 'mrw-pop';
    pop.setAttribute('aria-labelledby', 'mrw-pop-title');
    pop.innerHTML =
      '<canvas class="mrw-pop__cv" aria-hidden="true"></canvas>' +
      '<div class="mrw-pop__card" role="document" tabindex="-1" autofocus data-mrw-burst>' +
        '<button type="button" class="mrw-pop__x" data-mrw-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="mrw-pop__badge" data-mrw-pop-icon></div>' +
        '<p class="mrw-pop__eyebrow">Congratulations</p>' +
        '<h2 class="mrw-pop__title" id="mrw-pop-title" data-mrw-pop-title></h2>' +
        '<p class="mrw-pop__body" data-mrw-pop-body></p>' +
        '<div class="mrw-pop__track mrw__track"><div class="mrw__fill" data-mrw-pop-fill></div></div>' +
        '<button type="button" class="mrw-pop__cta" data-mrw-close data-mrw-pop-cta></button>' +
        '<p class="mrw-pop__hint">Tap anywhere on this card to celebrate</p>' +
      '</div>';
    document.body.appendChild(pop);
    pop.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target.closest('[data-mrw-close]')) { closePop(); return; }
      if (e.target === pop) { closePop(); return; } /* backdrop */
      if (e.target.closest('[data-mrw-burst]')) {
        burst(e.clientX, e.clientY);
        if (!reduce && navigator.vibrate) { try { navigator.vibrate(18); } catch (err) {} }
      }
    });
    pop.addEventListener('cancel', function (e) { e.preventDefault(); e.stopPropagation(); closePop(); });
    pop.addEventListener('keydown', function (e) { if (e.key === 'Escape') e.stopPropagation(); });
    return pop;
  }
  function closePop() {
    if (!pop || !pop.open) return;
    pop.classList.add('is-out');
    setTimeout(function () {
      pop.classList.remove('is-out');
      try { pop.close(); } catch (e) { pop.removeAttribute('open'); }
    }, reduce ? 0 : 180);
  }
  function showPop(L) {
    var d = buildPop(), c = popCopy(L, state.total);
    d.querySelector('[data-mrw-pop-icon]').innerHTML = c.icon;
    d.querySelector('[data-mrw-pop-title]').innerHTML = c.title;
    d.querySelector('[data-mrw-pop-body]').innerHTML = c.body;
    d.querySelector('[data-mrw-pop-cta]').textContent = c.cta;
    var fill = d.querySelector('[data-mrw-pop-fill]');
    fill.style.transition = 'none';
    fill.style.transform = 'translateX(-100%)';
    d.classList.toggle('is-done', L >= 2);
    if (d.open) { try { d.close(); } catch (e) {} }
    try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
    keepOnTop();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fill.style.transition = '';
        fill.style.transform = 'translateX(-' + (100 - c.pct).toFixed(2) + '%)';
        var r = d.querySelector('.mrw-pop__card').getBoundingClientRect();
        burst(r.left + r.width / 2, r.top + 30, true);
      });
    });
  }
  /* The theme can open its drawer (another modal dialog) a moment after the cart
     changes. The newest modal wins the top layer, so if any other dialog opens while
     the pop-up is showing, re-open the pop-up so it stays in front. */
  var guard = null;
  function keepOnTop() {
    if (guard) guard.disconnect();
    if (!window.MutationObserver) return;
    guard = new MutationObserver(function (list) {
      if (!pop || !pop.open) { guard.disconnect(); return; }
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t !== pop && t.tagName === 'DIALOG' && t.open) {
          try { pop.close(); pop.showModal(); } catch (e) {}
          break;
        }
      }
    });
    guard.observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });
    setTimeout(function () { if (guard) guard.disconnect(); }, 5000);
  }
  function celebrate(L) {
    all().forEach(function (el) {
      el.classList.remove('is-pop');
      void el.offsetWidth;
      el.classList.add('is-pop');
      setTimeout(function () { el.classList.remove('is-pop'); }, 1500);
    });
    showPop(L);
  }
  var cvRun = null;
  function burst(x, y, big) {
    if (reduce || !pop || !pop.open) return;
    var cv = pop.querySelector('.mrw-pop__cv');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = window.innerWidth, H = window.innerHeight;
    if (!cvRun) {
      cv.width = W * dpr; cv.height = H * dpr;
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      cvRun = { ctx: cv.getContext('2d'), parts: [], W: W, H: H };
      cvRun.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    var colours = ['#1f7a54', '#2f9a6a', '#8fd1ad', '#cfe9da', '#141414', '#ffffff'];
    var small = W < 500;
    var n = big ? (small ? 120 : 170) : (small ? 70 : 90);
    for (var i = 0; i < n; i++) {
      var a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * (big ? 1.5 : 1.1);
      var sp = (big ? 7 : 5) + Math.random() * (big ? 11 : 8);
      cvRun.parts.push({
        x: x + (Math.random() - 0.5) * (big ? (small ? 80 : 120) : 30), y: y,
        vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 2,
        w: 5 + Math.random() * 5, h: 7 + Math.random() * 7,
        rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.35,
        c: colours[(Math.random() * colours.length) | 0], round: Math.random() < 0.3,
        born: performance.now(), life: 2000 + Math.random() * 700
      });
    }
    if (cvRun.loop) return;
    cvRun.loop = true;
    (function frame(now) {
      var R = cvRun, ctx = R.ctx;
      ctx.clearRect(0, 0, R.W, R.H);
      R.parts = R.parts.filter(function (q) { return now - q.born < q.life && q.y < R.H + 40; });
      R.parts.forEach(function (q) {
        var age = now - q.born;
        q.vy += 0.28; q.vx *= 0.985; q.vy *= 0.985;
        q.x += q.vx; q.y += q.vy; q.rot += q.vr;
        ctx.save();
        ctx.globalAlpha = age > q.life - 500 ? Math.max(0, (q.life - age) / 500) : 1;
        ctx.translate(q.x, q.y);
        ctx.rotate(q.rot);
        ctx.fillStyle = q.c;
        if (q.round) { ctx.beginPath(); ctx.arc(0, 0, q.w / 2, 0, Math.PI * 2); ctx.fill(); }
        else {
          ctx.fillRect(-q.w / 2, -q.h / 2, q.w, q.h);
          if (q.c === '#ffffff') { ctx.strokeStyle = '#cfe9da'; ctx.lineWidth = 1; ctx.strokeRect(-q.w / 2, -q.h / 2, q.w, q.h); }
        }
        ctx.restore();
      });
      if (R.parts.length) requestAnimationFrame(frame);
      else { ctx.clearRect(0, 0, R.W, R.H); cvRun = null; }
    })(performance.now());
  }
  function checkUnlock() {
    var L = level(state.total, state.paid);
    var prev = store('mrw_lvl');
    store('mrw_lvl', String(L));
    if (prev !== null && L > Number(prev)) setTimeout(function () { celebrate(L); }, 350);
  }

  /* ---------- smart picks (drawer) ---------- */
  var upHTML = '', upSig = '', pool = null, recCache = {};
  function normPool(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return null;
    var img = p.images && p.images[0] ? (p.images[0].src || p.images[0]) : '';
    return { id: p.id, handle: p.handle, title: p.title, price: Math.round(parseFloat(v.price) * 100), vid: v.id, img: img };
  }
  function normRec(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return null;
    return { id: p.id, handle: p.handle, title: p.title, price: typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100), vid: v.id, img: p.featured_image || '', rec: true };
  }
  function loadPool() {
    if (pool) return Promise.resolve(pool);
    return nativeFetch('/collections/all/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { pool = (d.products || []).map(normPool).filter(Boolean); return pool; })
      .catch(function () { pool = []; return pool; });
  }
  function loadRecs(pid) {
    if (!pid) return Promise.resolve([]);
    if (recCache[pid]) return Promise.resolve(recCache[pid]);
    return nativeFetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { recCache[pid] = (d.products || []).map(normRec).filter(Boolean); return recCache[pid]; })
      .catch(function () { return []; });
  }
  function imgUrl(src) {
    if (!src) return '';
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function chipFor(price) {
    var after = state.total + price, now = gift(state.total), then = gift(after);
    if (then && now && then.min > now.min) return 'Unlocks ' + short(then);
    if (state.total < T1 && after >= T1) return 'Unlocks free delivery';
    return '';
  }
  function pick(recs, inCart) {
    var seen = {}, cands = [];
    recs.concat(pool || []).forEach(function (p) {
      if (!p || seen[p.id] || p.handle === HANDLE || inCart.indexOf(p.id) > -1 || !p.vid) return;
      seen[p.id] = true;
      cands.push(p);
    });
    var L = level(state.total, state.paid);
    if (L === MAX) return cands.filter(function (p) { return p.rec; }).slice(0, 3);
    var gap = (state.total < T1 ? T1 : nextGift(state.total).min) - state.total;
    var fit = cands.filter(function (p) { return p.price >= gap; });
    if (!fit.length) return cands.sort(function (a, b) { return b.price - a.price; }).slice(0, 3);
    /* cheapest product that closes the gap wins; related products get a GBP 15 head start */
    return fit.sort(function (a, b) {
      return ((a.price - gap) + (a.rec ? 0 : 1500)) - ((b.price - gap) + (b.rec ? 0 : 1500));
    }).slice(0, 3);
  }
  function renderUp(list) {
    var L = level(state.total, state.paid);
    if (!list.length) return '';
    var nx = nextGift(state.total);
    var head = L === MAX ? 'Complete your routine' : (state.total >= T1 && nx ? 'Top up for ' + nx.name : 'Top up for free UK delivery');
    return '<p class="mrw-up__h">' + esc(head) + '</p><ul class="mrw-up__list">' +
      list.map(function (p) {
        var chip = L < MAX ? chipFor(p.price) : '';
        return '<li class="mrw-up__i">' +
          (p.img ? '<img class="mrw-up__img" src="' + esc(imgUrl(p.img)) + '" alt="" width="52" height="52" loading="lazy">' : '<span class="mrw-up__img"></span>') +
          '<div class="mrw-up__t"><a class="mrw-up__n" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
          '<p class="mrw-up__p"><span>' + money(p.price) + '</span>' + (chip ? '<span class="mrw-up__chip">' + esc(chip) + '</span>' : '') + '</p></div>' +
          '<button type="button" class="mrw-up__add" data-mrw-add="' + p.vid + '" aria-label="Add ' + esc(p.title) + '">Add</button></li>';
      }).join('') + '</ul>';
  }
  function updateUp() {
    if (!document.querySelector('cart-drawer-component') || !state.paid) { upHTML = ''; place(); return; }
    var sig = level(state.total, state.paid) + '|' + state.total + '|' + state.ids.slice().sort().join(',');
    if (sig === upSig) return;
    upSig = sig;
    Promise.all([loadPool(), loadRecs(state.ids[0])]).then(function (res) {
      if (sig !== upSig) return;
      upHTML = renderUp(pick(res[1], state.ids));
      var up = document.getElementById('mrw-up');
      if (up && upHTML) up.innerHTML = upHTML;
      place();
    });
  }

  /* ---------- refresh loop ---------- */
  var busy = false, again = false, timer = null;
  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    getCart()
      .then(reconcile)
      .then(function (res) {
        state.total = res.cart.total_price || 0;
        state.paid = res.paid;
        state.ids = res.ids;
        state.coded = !!res.coded;
        place();
        paintAll();
        if (res.changed) ping(res.cart);
        checkUnlock();
        updateUp();
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; soon(); }
      });
  }
  function soon() { clearTimeout(timer); timer = setTimeout(refresh, 160); }

  document.addEventListener('cart:update', function (ev) {
    if (ev && ev.detail && ev.detail.sourceId === SRC) return;
    soon();
  });
  document.addEventListener('cart:refresh', soon);
  window.fetch = function (input) {
    var url = (input && input.url) || input || '';
    var p = nativeFetch.apply(window, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { soon(); }).catch(function () {});
    }
    return p;
  };

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-mrw-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      add.textContent = 'Adding';
      post('/cart/add.js', { items: [{ id: Number(add.getAttribute('data-mrw-add')), quantity: 1 }] })
        .then(getCart)
        .then(function (c) { ping(c); soon(); })
        .catch(function () { add.disabled = false; add.textContent = 'Add'; });
      return;
    }
    if (e.target.closest && e.target.closest('[data-mrw-dismiss]')) {
      store('mrw_pill_off', '1');
      place();
      return;
    }
    if (e.target.closest && e.target.closest('[data-mrw-view]')) {
      var trig = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trig) trig.click(); else window.location.href = '/cart';
    }
  });

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; place(); });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function () { place(); paintAll(); });

  place();
  paintAll();
  checkUnlock();
  refresh();
})();
